module.exports = __webpack_public_path__ + "img/DND.773aed96.webp";